var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseChatWidget(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M32.7,30.33l6.95-6.94A1.91,1.91,0,0,0,37,20.68l-7,7-6.95-6.95a1.91,1.91,0,0,0-2.7,2.71l7,6.94-6.95,7a1.91,1.91,0,0,0,2.7,2.7L30,33,37,40a1.91,1.91,0,0,0,2.7-2.7Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseChatWidget);
export default __webpack_public_path__ + "static/media/close-chat-widget.dbc20f496ca23db5abb6cedc9280cdf2.svg";
export { ForwardRef as ReactComponent };